export default __webpack_public_path__ + "static/media/chartres4.0452ae6c.jpg";